import englishMessages from 'ra-language-english'
import polyglotI18nProvider from 'ra-i18n-polyglot'
import frenchMessages from 'ra-language-french'

import frenchTranslationFile from './fr/french.json'
import englishTranslationFile from './en/english.json'
import arabicTranslationFile from './ar/arabic.json'
import russianTranslationFile from './ru-RU/russian.json'
import kazakhTranslationFile from './kk-KZ/kazakh.json'

const messages = {
  fr: { ...frenchMessages, ...frenchTranslationFile },
  en: { ...englishMessages, ...englishTranslationFile },
  ar: { ...englishMessages, ...arabicTranslationFile },
  'ru-RU': { ...englishMessages, ...russianTranslationFile },
  'kk-KZ': { ...englishMessages, ...kazakhTranslationFile },
}

const FALLBACK_LNG = 'en'

// 'ru' was the legacy locale key for Russian; migrate stored preference to 'ru-RU'
const storedLanguage = localStorage.getItem('language')

const i18nProvider = polyglotI18nProvider(
  locale => {
    return messages[locale]
  },
  (storedLanguage === 'ru' ? 'ru-RU' : storedLanguage) ?? 'en',
  {
    allowMissing: true,
    onMissingKey: (
      key: string,
      options: Record<string, unknown> & { locale?: string },
      curLocale: string,
    ): string => {
      const locale = options.locale ?? curLocale
      if (locale === FALLBACK_LNG) {
        return key
      }

      return i18nProvider.translate(key, {
        ...options,
        locale: FALLBACK_LNG,
      })
    },
  },
)

export default i18nProvider
